import { render } from "./PersonalPlan.vue?vue&type=template&id=e3dccd2a&scoped=true"
import script from "./PersonalPlan.vue?vue&type=script&lang=js"
export * from "./PersonalPlan.vue?vue&type=script&lang=js"

import "./PersonalPlan.vue?vue&type=style&index=0&id=e3dccd2a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3dccd2a"]])

export default __exports__